/* eslint-disable react/jsx-props-no-spreading */
// /* eslint-disable jsx-a11y/label-has-associated-control */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as btnStyles from '../styles/button.module.css';
import * as contactFormStyles from '../styles/contact-form.module.css';

const config = {
  script: 'https://script.google.com/macros/s/AKfycbwuNvE0NnUiDud89s4PENN3G999kSue5-xqMJGrhBJeNH-2ER_o-qLfaFLBzjpmxqUMMw/exec',
  sheet: 'response',
};

export default function ContactForm({ formTitle }) {
  const { register, handleSubmit } = useForm();

  const [sent, setSent] = React.useState(false);

  const onSubmit = React.useCallback((data) => {
    const { honeypot } = data;

    // checking if bot
    if (honeypot) {
      return false;
    }

    // use xhr as axios won't work (CORS)
    const xhr = new XMLHttpRequest();
    xhr.open('POST', config.script);
    // xhr.withCredentials = true
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function xhrGo() {
      setSent(true);
    };

    // preparing data
    const encoded = Object.keys(data)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`)
      .join('&');

    // finally sending
    xhr.send(encoded);
    return true;
  }, []);

  return (
    <>
      {sent ? (
        <div className={contactFormStyles.formTitleFont} style={{ paddingTop: '5vh' }}>
          <h1>Thanks for contacting us! We will get back to you soon!</h1>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <h1 className={contactFormStyles.formTitleFont} style={{ paddingBottom: '5vh' }}>{formTitle}</h1>
          <div>
            <label htmlFor="name" className={`${contactFormStyles.labelFont} ${contactFormStyles.labelContainer}`}>
              Name
              <input
                className={`${contactFormStyles.inputContainer}`}
                id="name"
                key="name"
                {...register('name')}
              />
            </label>

            <label htmlFor="subject" className={`${contactFormStyles.labelFont} ${contactFormStyles.labelContainer}`}>
              Subject
              <input
                className={`${contactFormStyles.inputContainer}`}
                id="subject"
                key="subject"
                {...register('subject')}
              />
            </label>

            <label htmlFor="message" className={`${contactFormStyles.labelFont} ${contactFormStyles.labelContainer}`}>
              Message
              <textarea
                style={{
                  height: 'auto', overflow: 'auto', resize: 'vertical', marginBottom: '2vh',
                }}
                className={`${contactFormStyles.inputContainer}`}
                id="message"
                key="message"
                {...register('message')}
                rows={10}
              />
            </label>

            <div style={{
              display: 'flex', justifyContent: 'space-between', marginBottom: '2vh', width: '105.5%',
            }}
            >
              <label htmlFor="email" className={`${contactFormStyles.labelFont} ${contactFormStyles.labelContainer}`}>
                Email Address
                <input
                  className={`${contactFormStyles.inputContainer}`}
                  style={{ width: '90%' }}
                  id="email"
                  key="email"
                  {...register('email')}
                  type="email"
                  required
                />
              </label>

              <label htmlFor="phone" className={`${contactFormStyles.labelFont} ${contactFormStyles.labelContainer}`}>
                Phone Number
                <input
                  className={`${contactFormStyles.inputContainer}`}
                  style={{ width: '90%' }}
                  id="phone"
                  key="phone"
                  {...register('phone')}
                  type="tel"
                  required
                />
              </label>
            </div>

            <label htmlFor="honeypot" style={{ display: 'none' }}>
              {/* To help avoid spam, utilize a Honeypot technique with a hidden text field; must
                  be empty to submit the form! Otherwise, we assume the user is a spam bot. */}
              <input id="honeypot" key="honeypot" type="text" {...register('honeypot')} />
            </label>

            <button type="submit" className={`${btnStyles.btnContainer} ${btnStyles.btnTitleFont}`}><span>Submit</span></button>
          </div>
        </form>
      )}
    </>
  );
}
